import React from 'react';
import PackDisabledPanel from '../components/PackDisabledPanel';
import { useFeaturePacks } from '../store/FeaturePackContext';
import { PACK_DEFINITIONS } from '../config/featurePacks';

const getPackName = (packId) => PACK_DEFINITIONS.find((pack) => pack.id === packId)?.name || packId;

export default function PackRoute({ pack, children }) {
  const { packs } = useFeaturePacks();
  if (pack && packs?.[pack] === false) {
    return <PackDisabledPanel packName={getPackName(pack)} />;
  }
  return children;
}
